import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Auth from '../Function/Auth';
import { toast, ToastContainer } from "react-toastify";

function Setting() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false);
  const [masterData, setMasterData] = useState(true);

  //Stake Setting
  const [minimumStake, setMinimumStake] = useState(0);
  const [businessCount, setBusinessCount] = useState(0);
  const [levelCount, setLevelCount] = useState("");
  const [stakeCapping, setStakeCapping] = useState("");
  const [incomeCapping, setIncomeCapping] = useState("");
  const [directIncome, setDirectIncome] = useState("");
  const [depositAddress, setDepositAddress] = useState("");


  //Withdraw setting
  const [withdrawType, setWithdrawType] = useState("");
  const [withdrawStatus, setWithdrawStatus] = useState("");
  const [minWithdraw, setMinWithdraw] = useState("");
  const [maxWithdraw, setMaxWithdraw] = useState("");
  const [withdrawHours, setWithdrawHours] = useState("");
  const [withdrawFees, setWithdrawFees] = useState("");


  useEffect(() => {
    fetchMasterData();
  }, [authToken]);



  const fetchMasterData = async () => {
    try {
      const response = await fetch(`${baseurl}/masterData`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return;
      }
      const result = await response.json();
      if (result.status) {
        setMasterData(result.data);
        const masterData = result.data;
        setMinimumStake(masterData.minimum_stake); setBusinessCount(masterData.business_count); setLevelCount(masterData.level_count); setStakeCapping(masterData.stake_capping); setIncomeCapping(masterData.income_capping); setDirectIncome(masterData.direct_income);
        setWithdrawType(masterData.withdraw_type); setWithdrawStatus(masterData.withdraw_status); setMinWithdraw(masterData.min_withdraw); setMaxWithdraw(masterData.max_withdraw); setWithdrawHours(masterData.withdraw_hours); setWithdrawFees(masterData.withdraw_fees_percentage); setDepositAddress(masterData.deposit_address);
        setTableLoading(true)
      }
    } catch (error) {
    }
  };


  const updateIncomeSetting = async () => {

    if (!minimumStake) return toast.error("Please Minimum Stake.");
    if (!businessCount) return toast.error("Pleae Business Count.");
    if (!levelCount) return toast.error("Please Level Cont.");
    if (!stakeCapping) return toast.error("Please Stake Capping.");
    if (!incomeCapping) return toast.error("Please Income Cappiing.");
    if (!directIncome) return toast.error("Please Direct Income.");

    const formData = {
      minimumStake: minimumStake,
      businessCount: businessCount,
      levelCount: levelCount,
      stakeCapping: stakeCapping,
      income_capping: incomeCapping,
      directIncome: directIncome,
    };


    try {
      const response = await fetch(`${baseurl}/updateStakeIncome`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      //   console.log("Raw API Response:", data); // Log response before parsing

      if (data.status) {
        toast.success(data.message)
        fetchMasterData();
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Network error. Please check your connection and try again.");
    }

  }



  const updateWithdraw = async () => {

    if (!withdrawType) return toast.error("Please Select type.");
    if (!withdrawStatus) return toast.error("Pleae Select Withdraw Status.");
    if (!minWithdraw) return toast.error("Please enter minimum withdraw.");
    if (!maxWithdraw) return toast.error("Please max withdraw.");
    if (!withdrawHours) return toast.error("Please enter withdraw hours.");
    if (!withdrawFees) return toast.error("Please withdraw fees.");

    const formData = {
      withdrawType: withdrawType,
      withdrawStatus: withdrawStatus,
      min_withdraw: minWithdraw,
      max_withdraw: maxWithdraw,
      withdraw_hours: withdrawHours,
      withdraw_fees: withdrawFees,
    };


    try {
      const response = await fetch(`${baseurl}/updateWithdrawSetting`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      //   console.log("Raw API Response:", data); // Log response before parsing

      if (data.status) {
        toast.success(data.message)
        fetchMasterData();
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Network error. Please check your connection and try again.");
    }

  }


  const updateDepositAddress = async () => {
    if (!depositAddress) return toast.error("Please Enter Deposit address .");

    const formData = {
      deposit_address: depositAddress,
    };


    try {
      const response = await fetch(`${baseurl}/update-deposit-address`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      //   console.log("Raw API Response:", data); // Log response before parsing

      if (data.status) {
        toast.success(data.message)
        fetchMasterData();
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Network error. Please check your connection and try again.");
    }
  }



  return (
    <>
      <Header>
        <Auth />
        <ToastContainer />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Setting !</h4>

              </div>
            </div>
            {/* End Page Header */}

            <div className="row">

              <div className="col-xl-12 col-lg-12">
                <div className="card">
                  {tabelLoading ? (
                    <div className="card-body">

                      <div className="tabs-menu ">
                        {/* Tabs */}
                        <ul className="nav nav-tabs profile navtab-custom panel-tabs">
                          <li className="">
                            <a href="#home" data-bs-toggle="tab" className="active" aria-expanded="true">
                              <span className="visible-xs"><i className="las la-key fs-16 me-1" /></span>
                              <span className="hidden-xs">TRADE & INCOME</span>
                            </a>
                          </li>
                          <li className="">
                            <a href="#friends01" data-bs-toggle="tab" aria-expanded="false">
                              <span className="visible-xs"><i className="las la-life-ring fs-16 me-1" /></span>
                              <span className="hidden-xs">WITHDRAW SETTING</span>
                            </a>
                          </li>

                          <li className="">
                            <a href="#gallery" data-bs-toggle="tab" aria-expanded="false">
                              <span className="visible-xs"><i className="las la-images fs-15 me-1" /> </span>
                              <span className="hidden-xs">Deposit</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content border border-top-0 p-4 br-dark">
                        <div className="tab-pane border-0 p-0 active" id="home">
                          <div className="row">
                            <div className="body">
                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Minimum Stake</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="number" className="form-control" value={minimumStake} onChange={(e) => setMinimumStake(e.target.value)} placeholder="Enter Minimum stake amount" />
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Business Count upto Level</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="number" className="form-control" value={businessCount} onChange={(e) => setBusinessCount(e.target.value)} placeholder="Enter Level for the business count" />
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Team Count upto Level</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="number" className="form-control" value={levelCount} onChange={(e) => setLevelCount(e.target.value)} placeholder="Enter Level for the team count" />
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Trade Capping in X</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="text" className="form-control" value={stakeCapping} onChange={(e) => setStakeCapping(e.target.value)} placeholder="Inter Capping amount for the stake in 2x or 3x" />
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Income Capping in X</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="text" className="form-control" value={incomeCapping} onChange={(e) => setIncomeCapping(e.target.value)} placeholder="Enter Capping amount for income  as 2 = 2x " />
                                </div>
                              </div>
                              <div className="row mt-5">
                                <div className="col-xl-4 col-md-4 col-12">
                                  <h6>Direct Income %</h6>
                                </div>
                                <div className="col-xl-8 col-md-8 col-12">
                                  <input type="text" className="form-control" value={directIncome} onChange={(e) => setDirectIncome(e.target.value)} placeholder="Enter Dircet income in percentage" readOnly />
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-xl-12 col-md-12 col-12 text-end">
                                  <button className="btn btn-primary" onClick={updateIncomeSetting}>Submit</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane border-0 p-0" id="friends01">



                          <div className="body">
                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Withdraw type</h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <select className="form-control" onChange={(e) => setWithdrawType(e.target.value)}>
                                  <option value={withdrawType}>{withdrawType}</option>
                                  <option value={"auto"}>auto</option>
                                  <option value={"manual"}>manual</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Withdraw Status</h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <select className="form-control" onChange={(e) => setWithdrawStatus(e.target.value)}>
                                  <option value={withdrawStatus}>{withdrawStatus}</option>
                                  <option value={"enable"}>enable</option>
                                  <option value={"disable"}>disable</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Minimum Withdraw</h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <input type="number" className="form-control" value={minWithdraw} onChange={(e) => setMinWithdraw(e.target.value)} placeholder="Enter Level for the business count" />
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Maximum Withdraw </h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <input type="number" className="form-control" value={maxWithdraw} onChange={(e) => setMaxWithdraw(e.target.value)} placeholder="Enter Level for the team count" />
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Withdraw Limit in Hours</h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <input type="text" className="form-control" value={withdrawHours} onChange={(e) => setWithdrawHours(e.target.value)} placeholder="Inter Capping amount for the stake in 2x or 3x" />
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-4 col-md-4 col-12">
                                <h6>Withdraw Fees in %</h6>
                              </div>
                              <div className="col-xl-8 col-md-8 col-12">
                                <input type="text" className="form-control" value={withdrawFees} onChange={(e) => setWithdrawFees(e.target.value)} placeholder="Enter Capping amount for income  as 2 = 2x " />
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-xl-12 col-md-12 col-12 text-end">
                                <button className="btn btn-primary" onClick={updateWithdraw}>Submit</button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane border-0 p-0" id="gallery" role="tabpanel">
                          <div className="row">
                            <div className="table-responsive country-table">
                              <div className="body">


                                <div className="row mt-5">
                                  <div className="col-xl-4 col-md-4 col-12">
                                    <h6>Deposit Address</h6>
                                  </div>
                                  <div className="col-xl-8 col-md-8 col-12">
                                    <input type="text" className="form-control" value={depositAddress} onChange={(e) => setDepositAddress(e.target.value)} placeholder="Enter Deposit Address" />
                                  </div>
                                </div>


                                <div className="row mt-5">
                                  <div className="col-xl-12 col-md-12 col-12 text-end">
                                    <button className="btn btn-primary" onClick={updateDepositAddress}>Submit</button>
                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  ) : (
                    <div className="cord-body">
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  )}
                </div>
              </div>
            </div>


          </div>
        </div>
      </Header>



    </>
  )
}

export default Setting